import React from 'react';
import { IProps as IBlockProps } from './HeroSearchBlock.interface';
import { HeroSearchBlock } from './HeroSearchBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IBlockInputProps {
    heading?: string;
    autoCompleteApiUrl?: string;
    autoCompleteRedirectUrl?: string;
    autoCompletePlaceholder?: string;
    autoCompleteButtonText?: string;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { heading, content, parentClass, anchorId, buttons, ...rest } = input;

    return {
        title: heading,
        // TODO -- Add Autocomplete props
        backgroundGradient: 'gradient-1',
        paddingBottom: 'small',
        paddingTop: 'small',
        ...rest,
    }
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={HeroSearchBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;